__turbopack_context__.v({
  "links": "index-module__p9UIKW__links",
});
